module.exports = __webpack_public_path__ + "static/profil-172_optimized-c62179ad6f626834a8d461e22136f546.jpg";